export const categoryColors = {
  "Geral": "#000080",
  "Meio ambiente": "#28a745",
  "Moradia": "#795548",
  "Nota de pesar": "#343a40",
  "Política": "#007bff",
  "Programas sociais": "#17a2b8",
  "Agricultura": "#8bc34a",
  "Assistência Social": "#ff9800",
  "Cidadania": "#9c27b0",
  "Cultura": "#e91e63",
  "Educação": "#ffc107",
  "Esportes": "#4caf50",
  "Eventos": "#00bcd4",
  "Finanças": "#3f51b5",
  "Infraestrutura": "#607d8b",
  "Institucional": "#f44336",
  "Interesse público": "#009688",
  "Saúde": "#cddc39",
  "Segurança": "#ff5722",
  "Servidores": "#673ab7",
  "Trânsito": "#ffeb3b",
  "Turismo": "#2196f3",
  "Pesca": "#03a9f4",
};